import { useNavigate } from "react-router-dom";
import { useState } from "react";

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
      e.preventDefault(); // Empêche le rechargement de la page
      console.log("Form submitted"); // Vérifie si la fonction est exécutée

      if (!email.includes("@")) {
          setError("L'adresse e-mail doit contenir @");
          return;
      }

      setError(""); // Réinitialise l'erreur si l'email est valide
      alert("Connexion réussie !");
  };

  return (
    <div className="w-full h-screen bg-cover bg-center relative">
      {/* Navbar */}
      <nav className="bg-blue-600 text-white flex justify-between items-center px-6 py-4">
          <div className="text-lg font-bold">logo et le nom</div>
          <div className="space-x-20">
            <a onClick={() => navigate("/")} className="hover:underline text-[20px] cursor-pointer">Accueil</a>
            <a onClick={() => navigate("/devis")} className="hover:underline text-[20px]">Devis</a>
            <button className="hover:underline text-[20px]">Avis</button>
          </div>
          <div className="flex items-center space-x-4">
            <div className="flex flex-col items-start">
              <button className="bg-red-500 px-4 py-2 rounded-md font-bold text-white">06 06 06 06 06</button>
              <span className="mt-2 text-sm">assistant client</span>
            </div>
          </div>
      </nav>

      {/* Contenu principal */}
      <div className="text-center mt-12">
        <h1 className="text-4xl font-bold">logo</h1>
        <p className="text-lg text-gray-600">nom</p>

        {/* Formulaire de connexion */}
        <form onSubmit={handleSubmit} className="flex flex-col items-center mt-10 space-y-6">
          <input
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}  
            className="w-80 p-3 border rounded-lg bg-gray-200"
            required
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <input
            type="password"
            placeholder="Mot de passe"
            className="w-80 p-3 border rounded-lg bg-gray-200"
            required
          />

          {/* Bouton de connexion */}
          <button type="submit" className="w-80 p-3 border-2 rounded-lg hover:bg-gray-200">
            Se connecter
          </button>
        </form>

        {/* Bouton pour créer un compte */}
        <div className="mt-6">
          <button onClick={() => navigate("/Createaccount")} className="w-80 p-3 bg-black text-white rounded-lg hover:bg-gray-800">
            Créé un compte
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
